import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
  UPDATE_USER_PREFERENCE_STARTING,
  UPDATE_USER_PREFERENCE_SUCCESS,
  UPDATE_USER_PREFERENCE_ERROR,
} from '../../constants/actionTypes';

export default function updateUserPreferenceReducer(state = initialState.updateUserPreference, action) {
  switch (action.type) {
    case UPDATE_USER_PREFERENCE_STARTING: {
      const { userPreferenceId } = action;
      const newState = clone(state);

      if (!newState[userPreferenceId]) {
        newState[userPreferenceId] = clone(initialState.updateUserPreference.userPreferenceId);
      }

      const updateData = newState[userPreferenceId];
      updateData.saving = true;
      updateData.saved = false;
      updateData.error = null;

      return newState;
    }

    case UPDATE_USER_PREFERENCE_SUCCESS: {
      const { userPreferenceId } = action;
      const newState = clone(state);

      if (!newState[userPreferenceId]) {
        newState[userPreferenceId] = clone(initialState.updateUserPreference.userPreferenceId);
      }

      const updateData = newState[userPreferenceId];
      updateData.saving = false;
      updateData.saved = true;
      updateData.error = null;
      return newState;
    }

    case UPDATE_USER_PREFERENCE_ERROR: {
      const { userPreferenceId } = action;
      const newState = clone(state);

      if (!newState[userPreferenceId]) {
        newState[userPreferenceId] = clone(initialState.updateUserPreference.userPreferenceId);
      }

      const updateData = newState[userPreferenceId];
      updateData.saving = false;
      updateData.saved = false;
      updateData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
